module.exports = __webpack_public_path__ + "img/3_110.136594a8.png";